<template>
  <!-- <div class="relative overflow-hidden rounded-2xl shadow-lg"> -->
  <div class="relative overflow-hidden rounded-2xl shadow-lg pb-16 md:pb-0">

    <!-- Slides -->
    <div class="flex transition-transform duration-700 ease-in-out"
      :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
      <!-- <div v-for="(slide, index) in slides" :key="index" class="min-w-full relative">
        <img :src="slide.image" :alt="slide.alt" class="w-full h-auto object-cover" />

        <div v-if="slide.caption" class="absolute bottom-6 left-6 bg-black/60 text-white
           px-4 py-2 rounded-lg text-sm font-semibold">
          {{ slide.caption }}
        </div>
      </div> -->
      <div v-for="(slide, index) in slides" :key="index" class="min-w-full relative group">
        <!-- Image -->
        <img :src="slide.image" :alt="slide.alt" width="1536" height="1024"
          :loading="index === 0 ? 'eager' : 'lazy'" decoding="async" class="w-full h-auto object-cover" />

        <!-- Hover Overlay -->
        <div class="absolute inset-0 bg-black/30
         hidden md:block
         opacity-0 group-hover:opacity-100
         transition-opacity duration-300"></div>


        <!-- Bottom Actions -->
        <div class="absolute bottom-6 left-6 right-6
         hidden md:flex
         items-center justify-between
         opacity-0 translate-y-3
         group-hover:opacity-100 group-hover:translate-y-0
         transition-all duration-300">
          <!-- Left: Caption + Know more -->
          <div class="flex items-center gap-4">
            <!-- Caption -->
            <span class="bg-black/60 text-white
             px-4 py-2 rounded-full
             text-sm font-medium">
              {{ slide.caption }}
            </span>

            <!-- Know more -->
            <router-link :to="`/treatments/${slide.slug}`" class="border border-teal-300 text-teal-100
             px-4 py-2 rounded-full
             text-sm font-semibold
             backdrop-blur-sm bg-white/10
             hover:bg-teal-500/20
             transition">
              Know more
            </router-link>
          </div>

          <!-- Right: Book -->
          <router-link to="/book-appointment-dental-clinic-guwahati" class="bg-teal-600 text-white
           px-4 py-2 rounded-full
           text-sm font-semibold
           shadow-md hover:bg-teal-700
           transition">
            Book an Appointment
          </router-link>
        </div>


        <!-- Mobile Overlay CTA -->
        <div class="absolute inset-x-0 bottom-0
         md:hidden
         bg-gradient-to-t from-black/80 via-black/40 to-transparent
         px-4 pt-10 pb-4">
          <!-- CTA Row -->
          <div class="flex items-center justify-between">
            <!-- Know more (LEFT) -->
            <router-link :to="`/treatments/${slide.slug}`" class="border border-teal-300 text-teal-100
             px-4 py-2 rounded-full
             text-sm font-semibold
             backdrop-blur-sm bg-white/10">
              Know more
            </router-link>

            <!-- Book (RIGHT) -->
            <router-link to="/book-appointment-dental-clinic-guwahati" class="bg-teal-600 text-white
             px-4 py-2 rounded-full
             text-sm font-semibold shadow-lg">
              Book
            </router-link>
          </div>
        </div>


      </div>
    </div>
    <!-- Left Arrow -->
    <button @click="prev"
      class="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow">
      ‹
    </button>

    <!-- Right Arrow -->
    <button @click="next"
      class="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow">
      ›
    </button>

    <!-- Dots -->
    <div class="absolute bottom-2 md:bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
      <span v-for="(_, index) in slides" :key="index" @click="goTo(index)"
        class="w-3 h-3 rounded-full cursor-pointer transition" :class="currentIndex === index
          ? 'bg-[#924f19]'
          : 'bg-white/70 hover:bg-white'
          "></span>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const slides = [
  {
    image: "/dental-services/dental-implants.webp",
    alt: "Dental implants for permanent tooth replacement",
    caption: "Dental Implants",
    slug: "dental-implants-in-guwahati",
  },
  {
    image: "/dental-services/wisdom-tooth-removal.webp",
    alt: "Safe wisdom tooth removal procedure",
    caption: "Wisdom Tooth Removal",
    slug: "wisdom-tooth-removal-in-guwahati",
  },
  {
    image: "/dental-services/teeth-whitening.webp",
    alt: "Professional teeth whitening for a brighter smile",
    caption: "Teeth Whitening",
    slug: "teeth-whitening-in-guwahati",
  },
  {
    image: "/dental-services/ultrasonic-scaling.webp",
    alt: "Ultrasonic scaling for professional teeth cleaning",
    caption: "Teeth Cleaning / Scaling",
    slug: "teeth-cleaning-in-guwahati",
  },
  {
    image: "/dental-services/braces-aligners.webp",
    alt: "Braces and clear aligners for teeth alignment",
    caption: "Braces & Aligners",
    slug: "dental-braces-in-guwahati",
  },
  {
    image: "/dental-services/tooth-colored-restorations.webp",
    alt: "Tooth colored restorations for natural looking fillings",
    caption: "Dental Fillings",
    slug: "dental-filling-in-guwahati",
  },
  {
    image: "/dental-services/dentures1.webp",
    alt: "Custom dentures for comfortable tooth replacement",
    caption: "Dentures",
    slug: "dentures-in-guwahati",
  },
  {
    image: "/dental-services/root-canal-treatment.webp",
    alt: "Painless root canal treatment procedure",
    caption: "Root Canal Treatment",
    slug: "root-canal-treatment-in-guwahati",
  },
  {
    image: "/dental-services/kids-dentistry.webp",
    alt: "Gentle and friendly kids dentistry care",
    caption: "Kids Dentistry",
    slug: "kids-dentistry-in-guwahati",
  },
  {
    image: "/dental-services/crowns-bridges.webp",
    alt: "Dental crowns and bridges for restoring teeth",
    caption: "Dental Crowns & Bridges",
    slug: "tooth-replacement-in-guwahati",
  },
];



const currentIndex = ref(0);
let interval;

// Must match the "duration-700" transition class on the slide track above.
const TRANSITION_MS = 700;
const AUTOPLAY_MS = 4000;

// Guards against a slide jumping by 2 instead of 1 when a click handler
// double-fires (touch devices commonly synthesize both a touch-derived
// click and a real click) or when autoplay ticks right after a manual
// navigation. All navigation (arrows + dots) routes through this so every
// path gets the same protection.
const isTransitioning = ref(false);

const resetAutoplay = () => {
  clearInterval(interval);
  interval = setInterval(next, AUTOPLAY_MS);
};

const goTo = (index) => {
  if (isTransitioning.value) return;
  isTransitioning.value = true;
  currentIndex.value = ((index % slides.length) + slides.length) % slides.length;
  resetAutoplay();
  setTimeout(() => {
    isTransitioning.value = false;
  }, TRANSITION_MS);
};

const next = () => goTo(currentIndex.value + 1);
const prev = () => goTo(currentIndex.value - 1);

onMounted(() => {
  interval = setInterval(next, AUTOPLAY_MS);
});

onUnmounted(() => {
  clearInterval(interval);
});
</script>
